<template>
    <div class="block--figure" v-if="project.images.length > 0">
        <Slick class="slider-for" :options="{ slidesToShow: 1, arrows: false, fade: false, asNavFor: '.slider-nav' }">
            <img :src="image.paths.hd" v-for="image in project.images" :key="image.id">
        </Slick>

        <Slick class="slider-nav" :options="{ slidesToShow: 4, focusOnSelect: true, asNavFor: '.slider-for' }">
            <img :src="image.paths.hd" v-for="image in project.images" :key="image.id">
        </Slick>
    </div>
</template>

<script>
	import Slick from 'vue-slick'

	export default {
		components: { Slick },

		props: ['project'],
	}
</script>